var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('site-header'),_c('div',{staticClass:"main-app-container",class:_vm.containerClass},[_c('router-view')],1),_c('site-footer'),_c('vue-snotify'),_c('v-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }